// extracted by mini-css-extract-plugin
export default {"modal":"EditCompetitorsModal_modal__Fm1Gt","footer":"EditCompetitorsModal_footer__Plue+"};